import { Box, Typography } from "@mui/material";
import SimpleBarHorizontal from "components/SimpleBarHorizontal";
import CategoryList from "pages/product_category/CategoryList";
import SubCategoryList from "pages/product_category/SubCategoryList";
import React from "react";

const CategoryAndSubList = () => {
  const [selectedItem, setSelectedItem] = React.useState(null);
  return (
    <Box>
      <Typography variant="h6" marginBottom={1} color="text.primary">
        Choose a category
      </Typography>
      <SimpleBarHorizontal>
        <CategoryList
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
      </SimpleBarHorizontal>
      {selectedItem && <SubCategoryList category={selectedItem} />}
    </Box>
  );
};

export default CategoryAndSubList;
